/**
 * Extract Google Maps embed URL from iframe HTML or raw URL.
 */
export const extractGoogleMapsEmbedUrl = (input) => {
  if (!input?.trim()) return "";

  const trimmed = input.trim();
  const srcMatch = trimmed.match(/src=["']([^"']+)["']/i);
  if (srcMatch) {
    return srcMatch[1].trim();
  }

  if (/^https:\/\/(www\.)?google\.com\/maps\/embed/i.test(trimmed)) {
    return trimmed;
  }

  return trimmed;
};

export const isValidGoogleMapsEmbedUrl = (url) =>
  /^https:\/\/(www\.)?google\.com\/maps\/embed/i.test(url || "");
